export default __webpack_public_path__ + "static/media/GRN.bddbe5c9.svg";